export default {
	title: 'external_sensors',
	components: [
		{ title: 'temperature_units', component: 'ext_temperature_unit' },
		{ title: 'sensor_names', component: 'ext_sensor_names' },
		{ title: 'temperature_offset', component: 'ext_temperature_offset' },
		{ title: 'humidity_offset', component: 'ext_humidity_offset' },
	],
};
